import { format } from "date-fns";

import { useGetDealGeneralPartnerViewV3 } from "@vega-api/generated/deal/deal";

export const useExportFilename = (
  dealId: string,
  exportType: "prospects" | "tracking",
): string => {
  const { data: dealData } = useGetDealGeneralPartnerViewV3(dealId, {
    query: {
      enabled: !!dealId,
      select: (data) => data.data,
    },
  });

  const dealName = dealData?.deal.name ?? `deal-${dealId}`;
  const sanitizedDealName = dealName.replace(/[^a-zA-Z0-9]/g, "_");
  const timestamp = format(new Date(), "yyyyMMdd_HHmmss");

  return `${sanitizedDealName}_${exportType}_${timestamp}`;
};
